import SearchPopover from './SearchPopover'

export default SearchPopover



// WEBPACK FOOTER //
// ./src/legacy/containers/Popovers/SearchPopover/index.js